import { useTheme } from '@mui/material';
import Box from '@mui/material/Box';

type LoadSegmentProps = {
  startPosition: string;
  endPosition: string;
  isHovered?: boolean;
};

const LoadSegment = ({ startPosition, endPosition, isHovered }: LoadSegmentProps) => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        position: 'absolute',
        left: startPosition,
        right: endPosition,
        height: '100%',
        top: 2,
        border: `1px solid ${
          isHovered ? theme.brandV2.colors.treadBlack : theme.brandV2.colors.treadGray6
        }`,
        borderRadius: theme.brandV2.borderRadius,
        bgcolor: 'transparent',
      }}
    />
  );
};

export { LoadSegment };
